import { Redirect } from '@reach/router'
import React from 'react'

import { useLocation } from '../../utils/contexts/UrlProvider'

const OldRoutesRedirect = ({ path }) => {
  const { pathname, search } = useLocation() || {}
  const newPath = pathname.replace('/m', '').replace('/v2', '') + search

  return <Redirect to={newPath} noThrow />
}

export default OldRoutesRedirect
